import { queryClient } from '../api/query-client';
import { advanceWorkspaceGeneration } from './workspaceGeneration';

type WorkspaceCacheReset = () => void;

const workspaceCacheResets = new Map<string, WorkspaceCacheReset>();

export const registerWorkspaceCacheReset = (
  key: string,
  reset: WorkspaceCacheReset,
): (() => void) => {
  workspaceCacheResets.set(key, reset);
  return () => {
    if (workspaceCacheResets.get(key) === reset) {
      workspaceCacheResets.delete(key);
    }
  };
};

export const cancelWorkspaceQueries = async (): Promise<void> => {
  await queryClient.cancelQueries();
};

export const clearWorkspaceCaches = (): void => {
  advanceWorkspaceGeneration();
  queryClient.clear();

  workspaceCacheResets.forEach((reset) => reset());
};
